interface IOrderItem {
  productId: number
  optionId?: number
  trimId?: string
  name: string
  number: string
  installed: boolean
  quantity: number
  price: number
  installedPrice?: number
  optionPrice?: number
  total: number
  options?: number[]
  images?: any[]
  originalPrice?: number
}

export class OrderItem implements IOrderItem {
  productId!: number
  optionId!: number
  trimId!: string
  name!: string
  number!: string
  installed!: boolean
  quantity!: number
  price!: number
  installedPrice?: number
  optionPrice?: number
  total!: number
  options?: number[]
  images?: any[]
  originalPrice?: number

  constructor(params: IOrderItem) {
    Object.assign(this, params)
  }

}